import { Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { AppConfig } from '../../../../app-config';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { Constants } from '@app/core/config';

@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ConfigurationComponent implements OnInit {
    public styleSelectorToggle: boolean; // open configuration menu
    public layoutType: string; // layout type
    public rtlLayout: any; // rtl type
    public menuFixedLayout: any; // menu/navbar fixed flag
    public headerFixedLayout: any; // header fixed flag
    public boxLayout: any; // box layout flag
    public isColoredIcon: any; // menu icon color
    public headerBackgroundColor: string; // header background color
    public navbarBackgroundColor: string; // navbar background color
    public brandBackgroundColor: string; // brand/logo background color
    public navBackgorundImage: any; // navbar background image

    public menuDropdownIcon: string; // navbar background image
    public menuListIcon: string; // navbar background image

    public navActiveColor: string;
    public navTitleColor: string;
    public menuTitleHide: any;

    public headerBackColor: string;

    public appConfig: any;
    public isConfig: boolean;

    constructor(private zone: NgZone, private location: Location, private router: Router) {
        this.appConfig = AppConfig.config;
        this.setThemeLayout();
    }

    ngOnInit() {
        this.styleSelectorToggle = false;

        this.layoutType = this.appConfig['layoutType'];
        this.setLayout(this.layoutType);

        this.isColoredIcon = this.appConfig['navIconColor'];
        this.changeIconColor(this.isColoredIcon);

        this.headerBackgroundColor = this.appConfig['headerBackColor'];
        // this.navbarBackgroundColor = this.appConfig['navBackColor'];
        // this.brandBackgroundColor = this.appConfig['navBrandColor'];
        this.navBackgorundImage = this.appConfig['navBackImage'];

        this.setHeaderBackground(this.headerBackgroundColor);
        this.setNavbarBackground(this.navbarBackgroundColor);
        this.setBrandBackground(this.brandBackgroundColor);
        this.setBackgroundImage(this.navBackgorundImage);

        this.rtlLayout = this.appConfig['rtlLayout'];
        this.changeRtlLayout(this.rtlLayout);

        this.menuFixedLayout = this.appConfig['navFixedLayout'];
        if (this.appConfig['layout'] === 'vertical') {
            this.changeMenuFixedLayout(this.menuFixedLayout);
        }

        this.headerFixedLayout = this.appConfig['headerFixedLayout'];
        this.changeHeaderFixedLayout(this.headerFixedLayout);

        this.boxLayout = this.appConfig['boxLayout'];
        this.changeBoxLayout(this.boxLayout);

        this.menuDropdownIcon = this.appConfig['navDropdownIcon'];
        this.setMenuDropdownIcon(this.menuDropdownIcon);

        this.menuListIcon = this.appConfig['navListIcon'];
        this.setMenuListIcon(this.menuListIcon);

        this.navActiveColor = this.appConfig['navActiveListColor'];
        this.setNavActiveColor(this.navActiveColor);

        this.navTitleColor = this.appConfig['navListTitleColor'];
        this.setNavTitleColor(this.navTitleColor);

        this.menuTitleHide = this.appConfig['navListTitleHide'];
        this.changeMenuTitle(this.menuTitleHide);

        if (this.appConfig['preLayout'] !== '' && this.appConfig['preLayout'] !== null) {
            this.setPreBuildLayout(this.appConfig['preLayout']);
        }
        // this.router.navigate(['/dashboard/default']);
    }

    setThemeLayout() {
        let current_url = this.location.path();
        if (this.location['_baseHref']) {
            current_url = this.location['_baseHref'] + this.location.path();
        }

        switch (current_url) {
            case this.location['_baseHref'] + '/layout/static':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['navFixedLayout'] = false;
                this.appConfig['headerFixedLayout'] = false;
                break;
            case this.location['_baseHref'] + '/layout/fixed':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['navFixedLayout'] = true;
                this.appConfig['headerFixedLayout'] = true;
                break;
            case this.location['_baseHref'] + '/layout/nav-fixed':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['navFixedLayout'] = true;
                this.appConfig['headerFixedLayout'] = false;
                break;
            case this.location['_baseHref'] + '/layout/nav-image':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['navBackImage'] = 'navbar-image-3';
                break;
            case this.location['_baseHref'] + '/layout/collapseMenu':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['collapseMenu'] = true;
                break;
            case this.location['_baseHref'] + '/layout/horizontal':
                this.appConfig['layout'] = 'horizontal';
                break;
            case this.location['_baseHref'] + '/layout/box':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['boxLayout'] = true;
                this.appConfig['collapseMenu'] = true;
                break;
            case this.location['_baseHref'] + '/layout/rtl':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['rtlLayout'] = true;
                break;
            case this.location['_baseHref'] + '/layout/light':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['layoutType'] = 'menu-light';
                break;
            case this.location['_baseHref'] + '/layout/dark':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['layoutType'] = 'dark';
                this.appConfig['navBackColor'] = 'navbar-dark';
                this.appConfig['navBrandColor'] = 'brand-dark';
                break;
            case this.location['_baseHref'] + '/layout/icon-color':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['layoutType'] = 'menu-light';
                this.appConfig['navIconColor'] = true;
                break;
            case this.location['_baseHref'] + '/layout/layout-2':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-2';
                break;
            case this.location['_baseHref'] + '/layout/layout-2-2':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-2-2';
                break;
            case this.location['_baseHref'] + '/layout/layout-3':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-3';
                break;
            case this.location['_baseHref'] + '/layout/layout-4':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-4';
                break;
            case this.location['_baseHref'] + '/layout/layout-4-2':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-4-2';
                break;
            case this.location['_baseHref'] + '/layout/layout-5h':
                this.appConfig['layout'] = 'horizontal';
                this.appConfig['layoutType'] = 'menu-light';
                this.appConfig['navIconColor'] = true;
                this.appConfig['headerBackColor'] = 'header-blue';
                break;
            case this.location['_baseHref'] + '/layout/nav-color':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['layoutType'] = 'menu-light';
                this.appConfig['navIconColor'] = true;
                this.appConfig['headerBackColor'] = 'header-lightblue';
                this.appConfig['navBrandColor'] = 'brand-lightblue';
                this.appConfig['navFixedLayout'] = true;
                this.appConfig['headerFixedLayout'] = true;
                break;
            case this.location['_baseHref'] + '/layout/layout-6':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-6';
                this.appConfig['layoutType'] = 'menu-light';
                this.appConfig['navIconColor'] = true;
                this.appConfig['navBrandColor'] = 'brand-lightblue';
                this.appConfig['navFixedLayout'] = false;
                this.appConfig['headerFixedLayout'] = false;
                this.appConfig['layout6Background'] = '#23b7e5';
                break;
            case this.location['_baseHref'] + '/layout/layout-8':
                this.appConfig['layout'] = 'vertical';
                this.appConfig['preLayout'] = 'layout-8';
                this.appConfig['layoutType'] = 'menu-light';
                this.appConfig['headerBackColor'] = 'header-lightblue';
                this.appConfig['navBrandColor'] = 'brand-lightblue';
                this.appConfig['navFixedLayout'] = true;
                this.appConfig['headerFixedLayout'] = true;
                this.appConfig['navActiveListColor'] = 'active-lightblue';
                break;
            default:
                break;
        }
    }

    setPreBuildLayout(pre_layout) {
        if (pre_layout === 'layout-6') {
            document.querySelector('.pcoded-navbar').classList.add('menupos-static');
            this.headerBackColor = this.appConfig['layout6Background'];
            this.setHeaderBackColor(this.headerBackColor);
        }

        if (pre_layout !== 'layout-6' && pre_layout !== 'layout-8') {
            this.isConfig = false;
            document.querySelector('.pcoded-navbar').classList.add(pre_layout);
        } else {
            document.querySelector('body').classList.add(pre_layout);
        }
    }

    setHeaderBackColor(color) {
        this.headerBackColor = color;
        const e: HTMLElement = document.querySelector('body');
        e.style.background = color;
    }

    // change main layout
    setLayout(layout) {
        this.isConfig = true;
        if (environment.production) {
            if (environment.env == Constants.TEST) {
                this.navbarBackgroundColor = 'navbar-green';
            } else {
                this.navbarBackgroundColor = this.appConfig.navbarBackgroundColor;
            }
        } else {
            this.navbarBackgroundColor = 'navbar-orange';
        }
        this.setNavbarBackground(this.navbarBackgroundColor);
        this.setBrandBackground(this.appConfig['navBrandColor']);
        document.querySelector('.pcoded-navbar').classList.remove('menu-light');
        document.querySelector('.pcoded-navbar').classList.remove('menu-dark');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-dark');
        document.querySelector('.pcoded-navbar').classList.remove('brand-dark');
        document.querySelector('body').classList.remove('dark');
        this.setHeaderBackground('header-default');

        this.layoutType = layout;
        if (layout === 'menu-light') {
            this.setNavbarBackground(this.navbarBackgroundColor);
            this.setBrandBackground(this.brandBackgroundColor);
            document.querySelector('.pcoded-navbar').classList.add(layout);
        }
        if (layout === 'dark') {
            document.querySelector('.pcoded-navbar').classList.add('navbar-dark');
            document.querySelector('.pcoded-navbar').classList.add('brand-dark');

            this.setNavbarBackground('navbar-dark');
            this.setBrandBackground('brand-dark');

            if (this.appConfig['preLayout'] !== 'layout-6') {
                this.setHeaderBackground('header-dark');
            }

            document.querySelector('body').classList.add('dark');
        }
        if (layout === 'reset') {
            this.reset();
        }
    }

    reset() {
        document.querySelector('.pcoded-navbar').classList.remove('icon-colored');
        this.ngOnInit();
    }

    setColoredIcon(e) {
        const flag = !!e.target.checked;
        this.changeIconColor(flag);
    }

    changeIconColor(flag) {
        if (flag) {
            document.querySelector('.pcoded-navbar').classList.add('icon-colored');
        } else {
            document.querySelector('.pcoded-navbar').classList.remove('icon-colored');
        }
    }

    setRtlLayout(e) {
        const flag = !!e.target.checked;
        this.changeRtlLayout(flag);
    }

    changeRtlLayout(flag) {
        if (flag) {
            document.querySelector('body').classList.add('rtl');
        } else {
            document.querySelector('body').classList.remove('rtl');
        }
    }

    setMenuFixedLayout(e) {
        const flag = !!e.target.checked;
        this.changeMenuFixedLayout(flag);
    }

    changeMenuFixedLayout(flag) {
        setTimeout(() => {
            const e: HTMLElement = document.querySelector('#nav-ps-datta');
            if (flag) {
                document.querySelector('.pcoded-navbar').classList.remove('menupos-static');
                e.style.maxHeight = 'calc(100vh - 70px)';
            } else {
                document.querySelector('.pcoded-navbar').classList.add('menupos-static');
                e.style.maxHeight = '100%';
            }
        }, 100);
    }

    setHeaderFixedLayout(e) {
        const flag = !!e.target.checked;
        this.changeHeaderFixedLayout(flag);
    }

    changeHeaderFixedLayout(flag) {
        if (flag) {
            document.querySelector('.pcoded-header').classList.add('headerpos-fixed');
            document.querySelector('.pcoded-header').classList.add('header-blue');
        } else {
            document.querySelector('.pcoded-header').classList.remove('headerpos-fixed');
        }
    }

    setBoxLayout(e) {
        const flag = !!e.target.checked;
        this.changeBoxLayout(flag);
    }

    changeBoxLayout(flag) {
        if (flag) {
            document.querySelector('body').classList.add('container');
            document.querySelector('body').classList.add('boxLayout');
        } else {
            document.querySelector('body').classList.remove('boxLayout');
            document.querySelector('body').classList.remove('container');
        }
    }

    hideMenuTitle(e) {
        const flag = !!e.target.checked;
        this.changeMenuTitle(flag);
    }

    changeMenuTitle(flag) {
        if (flag) {
            document.querySelector('.pcoded-navbar').classList.add('caption-hide');
        } else {
            document.querySelector('.pcoded-navbar').classList.remove('caption-hide');
        }
    }

    setHeaderBackground(background) {
        this.headerBackgroundColor = background;
        document.querySelector('.pcoded-header').classList.remove('header-blue');
        document.querySelector('.pcoded-header').classList.remove('header-red');
        document.querySelector('.pcoded-header').classList.remove('header-purple');
        document.querySelector('.pcoded-header').classList.remove('header-lightblue');
        document.querySelector('.pcoded-header').classList.remove('header-dark');
        if (background !== 'header-default') {
            document.querySelector('.pcoded-header').classList.add(background);
        }
    }

    setNavbarBackground(background) {
        this.setBackgroundImage(this.appConfig['navBackImage']);
        this.navbarBackgroundColor = background;
        document.querySelector('.pcoded-navbar').classList.remove('navbar-blue');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-red');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-purple');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-lightblue');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-dark');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-green');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-orange');

        // add default menu brand background color
        document.querySelector('.pcoded-navbar').classList.add('brand-default');
        if (background !== 'navbar-default') {
            document.querySelector('.pcoded-navbar').classList.add(background);
        }
    }

    setBrandBackground(background) {
        this.brandBackgroundColor = background;
        document.querySelector('.pcoded-navbar').classList.remove('brand-default');
        document.querySelector('.pcoded-navbar').classList.remove('brand-blue');
        document.querySelector('.pcoded-navbar').classList.remove('brand-red');
        document.querySelector('.pcoded-navbar').classList.remove('brand-purple');
        document.querySelector('.pcoded-navbar').classList.remove('brand-lightblue');
        document.querySelector('.pcoded-navbar').classList.remove('brand-dark');
        document.querySelector('.pcoded-navbar').classList.remove('brand-green');
        document.querySelector('.pcoded-navbar').classList.remove('brand-orange');

        document.querySelector('.pcoded-navbar').classList.add(background);
    }

    setBackgroundImage(image) {
        document.querySelector('.pcoded-navbar').classList.remove('navbar-image-1');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-image-2');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-image-3');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-image-4');
        document.querySelector('.pcoded-navbar').classList.remove('navbar-image-5');
        if (image) {
            this.navBackgorundImage = image;
            document.querySelector('.pcoded-navbar').classList.add(image);
        }
    }

    setMenuDropdownIcon(icon) {
        document.querySelector('.pcoded-navbar').classList.remove('drp-icon-style1');
        document.querySelector('.pcoded-navbar').classList.remove('drp-icon-style2');
        document.querySelector('.pcoded-navbar').classList.remove('drp-icon-style3');
        if (icon !== 'style1') {
            document.querySelector('.pcoded-navbar').classList.add('drp-icon-' + icon);
        }
    }

    setMenuListIcon(icon) {
        document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style1');
        document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style2');
        document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style3');
        document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style4');
        document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style5');
        document.querySelector('.pcoded-navbar').classList.remove('menu-item-icon-style6');
        if (icon !== 'style1') {
            document.querySelector('.pcoded-navbar').classList.add('menu-item-icon-' + icon);
        }
    }

    setNavActiveColor(style) {
        this.navActiveColor = style;
        document.querySelector('.pcoded-navbar').classList.remove('active-default');
        document.querySelector('.pcoded-navbar').classList.remove('active-blue');
        document.querySelector('.pcoded-navbar').classList.remove('active-red');
        document.querySelector('.pcoded-navbar').classList.remove('active-purple');
        document.querySelector('.pcoded-navbar').classList.remove('active-lightblue');
        document.querySelector('.pcoded-navbar').classList.remove('active-dark');
        if (style !== 'active-default') {
            document.querySelector('.pcoded-navbar').classList.add(style);
        }
    }

    setNavTitleColor(style) {
        this.navTitleColor = style;
        document.querySelector('.pcoded-navbar').classList.remove('title-default');
        document.querySelector('.pcoded-navbar').classList.remove('title-blue');
        document.querySelector('.pcoded-navbar').classList.remove('title-red');
        document.querySelector('.pcoded-navbar').classList.remove('title-purple');
        document.querySelector('.pcoded-navbar').classList.remove('title-lightblue');
        document.querySelector('.pcoded-navbar').classList.remove('title-dark');
        if (style !== 'title-default') {
            document.querySelector('.pcoded-navbar').classList.add(style);
        }
    }
}
